const trackSticky = (entries) => {
	entries.forEach(e => e.target.classList.toggle('v3-state-stuck', e.intersectionRatio < 1));
};

const updateHeaderHeight = ([e]) => document.documentElement.style.setProperty("--v3-sys-topnav-height", `${e.borderBoxSize[0].blockSize}px`);

function initStickyTopbar() {
	const topbar = document.getElementById("td-toptab");
	if (topbar) {
		new IntersectionObserver(trackSticky, {	rootMargin: '-1px 0px 0px 0px',	threshold: [1] }).observe(topbar);
		new ResizeObserver(updateHeaderHeight).observe(topbar);
	}
}

export { initStickyTopbar as init };